import { LoginContext } from "./types/LoginContext";

export default class MLoginPopup {
  private _callbacks: { [event: string]: ((data?: unknown) => void)[] } = {};
  private _navigationHistory: string[] = [];

  private _context: LoginContext = LoginContext.SCHOOL;

  public get context(): LoginContext {
    return this._context;
  }

  private _steps: string[] = [];

  public get steps(): string[] {
    return this._steps;
  }

  private _currentStep: string = "login";

  public get currentStep(): string {
    if (!this._currentStep && this._steps.length > 0) {
      return this._steps[0];
    }
    return this._currentStep;
  }

  public set currentStep(step: string) {
    if (this._currentStep != step) {
      const oldStep = this._currentStep;
      if (oldStep) {
        this._navigationHistory.push(oldStep);
      }

      this._currentStep = step;
      this.emit("stepChanged", { oldStep, newStep: step });
    }
  }

  private _selectedPlatform?: string;

  public get selectedPlatform(): string | undefined {
    return this._selectedPlatform;
  }

  private _selectedUserType?: "TEACHER" | "STUDENT" | "CHILD" | "PARENT";

  public get selectedUserType():
    | "TEACHER"
    | "STUDENT"
    | "CHILD"
    | "PARENT"
    | undefined {
    return this._selectedUserType;
  }

  public set selectedUserType(
    userType: "TEACHER" | "STUDENT" | "CHILD" | "PARENT",
  ) {
    this._selectedUserType = userType;
  }

  public SetSelectedPlatform(platform: string): void {
    this._selectedPlatform = platform;
  }

  public SetContext(context: LoginContext, steps: string[]): void {
    this._context = context;
    this._steps = steps;
  }

  public GoToNextStep(): void {
    const currentIndex = this._steps.indexOf(this._currentStep);
    if (currentIndex < this._steps.length - 1) {
      this.currentStep = this._steps[currentIndex + 1];
    }
  }

  public GoToPreviousStep(): void {
    if (this._navigationHistory.length > 0) {
      const oldStep = this._currentStep;

      // We don't want the old step to be added to the history, so we can't use the currentStep setter property
      this._currentStep = this._navigationHistory.pop();
      this.emit("stepChanged", { oldStep, newStep: this._currentStep });
    }
  }

  public GoToStep(step: string): void {
    if (this._steps.includes(step)) {
      this.currentStep = step;
    }
  }

  // Event system
  public On(event: string, callback: (data?: unknown) => void): void {
    if (!this._callbacks[event]) {
      this._callbacks[event] = [];
    }
    this._callbacks[event].push(callback);
  }

  public Off(event: string, callback?: (data?: unknown) => void): void {
    if (!this._callbacks[event]) return;

    if (callback) {
      this._callbacks[event] = this._callbacks[event].filter(
        (cb) => cb !== callback,
      );
    } else {
      delete this._callbacks[event];
    }
  }

  public ShouldShowUserRoleSelection(): boolean {
    return (
      this._steps.includes("userrole") && this._context === LoginContext.SCHOOL
    );
  }

  public ShouldShowPlatformSelection(): boolean {
    return this._steps.includes("platform");
  }

  public ShouldShowBackLink(): boolean {
    return this._navigationHistory.length > 0;
  }

  public Reset(): void {
    this._context = LoginContext.SCHOOL;
    this._steps = [];
    this._currentStep = null;
    this._navigationHistory = [];
    this._selectedPlatform = undefined;
    this._selectedUserType = undefined;
    this.emit("reset");
  }

  private emit(event: string, data?: unknown): void {
    if (this._callbacks[event]) {
      this._callbacks[event].forEach((callback) => callback(data));
    }
  }
}
